"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const kor_1 = require("./kor");
const _ = __importStar(require("lodash"));
const lodash_1 = require("lodash");
const operators_1 = require("rxjs/operators");
const util_math_1 = require("./util_math");
const util_1 = require("./util");
const util_rx_1 = require("./util_rx");
class Transform {
    constructor({ move, rotate, scale } = {}) {
        this.move = move || kor_1.Point.ZERO;
        this.rotate = util_1.ifNumber(rotate, 0);
        this.scale = util_1.ifNumber(scale, 1);
    }
    plus(other) {
        return new Transform({
            move: this.move.rotate(other.rotate).scale(other.scale).add(other.move),
            rotate: this.rotate + other.rotate,
            scale: this.scale * other.scale
        });
    }
    repivot(pFrom, pTo) {
        const np = pFrom.add(this.move);
        const d1 = pTo.subtract(pFrom);
        const d2 = d1.rotate(this.rotate).scale(this.scale);
        return new Transform({ move: np.add(d2.subtract(pTo)),
            rotate: this.rotate, scale: this.scale });
    }
    get elements() {
        return [this.move.x, this.move.y, this.rotate, this.scale];
    }
}
exports.Transform = Transform;
Transform.ZERO = new Transform();
function calculateTransformFromEvents(pivot, event1, event2) {
    const touches1 = lodash_1.groupBy(event1.touches, 'identifier');
    const touches2 = lodash_1.groupBy(event2.touches, 'identifier');
    const common = lodash_1.intersection(lodash_1.keys(touches1), lodash_1.keys(touches2));
    if (common.length === 1) {
        const id = common[0];
        const touch1 = touches1[id][0];
        const touch2 = touches2[id][0];
        const move = touch2.point.subtract(touch1.point);
        return new Transform({ move });
    }
    else if (common.length >= 2) {
        const id1 = common[0];
        const id2 = common[1];
        const vector1 = [touches1[id1][0].point,
            touches1[id2][0].point];
        const vector2 = [touches2[id1][0].point,
            touches2[id2][0].point];
        const t = util_math_1.calculateTransformFromVectors2(pivot, vector1, vector2);
        if (t) {
            const { move, rotate, scale } = t;
            return new Transform({ move, rotate, scale });
        }
        else
            return Transform.ZERO;
    }
    return new Transform();
}
exports.calculateTransformFromEvents = calculateTransformFromEvents;
function transformsFromGesture(pivot = kor_1.Point.ZERO) {
    return gesture => gesture.pipe(operators_1.pairwise(), operators_1.map(([e1, e2]) => calculateTransformFromEvents(pivot, e1, e2)));
}
exports.transformsFromGesture = transformsFromGesture;
function transformsFromGestureWithEvents(pivot = kor_1.Point.ZERO) {
    return gesture => gesture.pipe(operators_1.pairwise(), operators_1.map(([e1, e2]) => [calculateTransformFromEvents(pivot, e1, e2), e1, e2]));
}
exports.transformsFromGestureWithEvents = transformsFromGestureWithEvents;
// Will grab the first touch (hopefully the ONLY touch) from the first event
function transformsFromRadialGesture(pivot) {
    return gesture => gesture.pipe(operators_1.scan((prevTouch, event) => prevTouch ?
        _.find(event.touches, (t) => t.identifier === prevTouch.identifier)
        : event.touches[0], undefined), util_rx_1.filterDefined(), util_rx_1.pairFirst(), operators_1.map(([t0, t]) => {
        const v0 = new kor_1.Vector(pivot, t0.point);
        const v = new kor_1.Vector(pivot, t.point);
        const rotate = v0.angleTo(v);
        const scale = v0.scaleTo(v);
        return new Transform({ rotate, scale });
    }));
}
exports.transformsFromRadialGesture = transformsFromRadialGesture;
// Will grab the first touch (hopefully the ONLY touch) from the first event
function transformsFromDirectedGesture(pivot, direction) {
    return gesture => gesture.pipe(operators_1.scan((prevTouch, event) => prevTouch ?
        _.find(event.touches, (t) => t.identifier === prevTouch.identifier)
        : event.touches[0], undefined), util_rx_1.filterDefined(), util_rx_1.pairFirst(), operators_1.map(([t0, t]) => {
        const v0 = new kor_1.Vector(pivot, t0.point);
        const v = new kor_1.Vector(pivot, t.point);
        const d0 = v0.toPoint().dot(direction);
        const d = v.toPoint().dot(direction);
        const scale = d / d0;
        return new Transform({ scale });
    }));
}
exports.transformsFromDirectedGesture = transformsFromDirectedGesture;
